<div class="overflow-hidden bg-background mx-1">
    <form
        class="flex flex-col h-full"
        [formGroup]="filterForm()!"
        (submit)="save()">
        <div class="bg-white rounded-xl py-4 mb-4 pl-4">
            <div class="flex justify-between items-center">
                <div class="field-intervention-header font-normal text-2xl pl-4 pt-2">
                    <app-title
                        class="header-title"
                        [title]="(isEditMode() ? 'mapFilter.edit' : 'mapFilter.createFilter') | transloco"
                        (goToPreviousPage)="goToPreviousPage()" />
                </div>
            </div>
        </div>

        <div class="flex flex-col flex-1 my-4 gap-1.5">
            <app-expansion-panel
                class="bg-white rounded-xl p-3"
                [disabled]="layersControl.value.length > 1"
                [isExpanded]="isDepositFoldersExpanded()"
                [matTooltip]="'mapFilter.cannotFilterOnDepositFolderWhenMultipleLayer' | transloco"
                [matTooltipDisabled]="layersControl.value.length <= 1">
                <app-panel-header
                    class="text-headline-6 font-medium"
                    header
                    [count]="depositFoldersControl.value.length"
                    [title]="'mapFilter.data'" />
                <app-deposit-layer-filter-form
                    content
                    [control]="depositFoldersControl"
                    [displayShowMore]="depositFolderTotalCount() > defaultNumberElementsDisplayed"
                    [editDisabled]="layersControl.value.length > 1 || isEditDisabled()"
                    [paneWidthTwoThird]="panelWidthTwoThird()"
                    [reset]="formReset()"
                    [searchLabel]="'searchDepositFolders' | transloco"
                    [totalCount]="depositFolderTotalCount()"
                    [values]="depositFolders()"
                    (search)="searchDeposit($event)"
                    (toggleShowAll)="toggleDepositFoldersShowAll($event)" />
            </app-expansion-panel>
            <app-expansion-panel
                class="bg-white rounded-xl p-3"
                [disabled]="depositFoldersControl.value.length > 1"
                [isExpanded]="isLayersExpanded()"
                [matTooltip]="'mapFilter.cannotFilterOnLayerWhenMultipleData' | transloco"
                [matTooltipDisabled]="depositFoldersControl.value.length <= 1">
                <app-panel-header
                    class="text-headline-6 font-medium"
                    header
                    [count]="layersControl.value.length"
                    [title]="'layers'" />
                <app-deposit-layer-filter-form
                    content
                    [control]="layersControl"
                    [displayShowMore]="layers().length > defaultNumberElementsDisplayed"
                    [editDisabled]="isEditDisabled()"
                    [paneWidthTwoThird]="panelWidthTwoThird()"
                    [reset]="formReset()"
                    [searchLabel]="'searchLayer' | transloco"
                    [totalCount]="layers().length"
                    [values]="displayedLayers()"
                    (search)="searchLayers($event)"
                    (toggleShowAll)="toggleLayerShowAll($event)" />
            </app-expansion-panel>
            <app-expansion-panel
                class="bg-white rounded-xl p-3"
                [disabled]="layersControl.value.length !== 1"
                [matTooltip]="'mapFilter.searchByAttributesAvailableWithOnlyOneLayer' | transloco"
                [matTooltipDisabled]="layersControl.value.length === 1"
                [(isExpanded)]="isLayerAttributesExpanded">
                <app-panel-header
                    class="text-headline-6 font-medium"
                    header
                    [count]="layerAttributesFormArray.length"
                    [title]="'attributes'" />
                <div
                    class="flex flex-col"
                    content>
                    <div class="w-full">
                        <ul class="list-none pl-0">
                            @for (layerAttributeForm of layerAttributesFormArray.controls; track layerAttributeForm) {
                                <li class="pb-2">
                                    <app-layer-attribute-filter-form
                                        [editDisabled]="isEditDisabled()"
                                        [layerAttributeForm]="layerAttributeForm"
                                        [layerAttributeFormId]="$index + 1"
                                        [layerAttributesOptions]="layerAttributesOptions()"
                                        [layerTableName]="layerTableName()"
                                        (remove)="removeLayerAttributeForm($index)" />
                                </li>

                                @if (!$last) {
                                    <li class="pb-2 text-sm text-gray-400 uppercase">
                                        <mat-divider class="w-12" />
                                    </li>
                                }
                            }
                        </ul>
                        <app-button
                            [disabled]="layerAttributesFormArray.invalid || isEditDisabled()"
                            [icon]="['fas', 'plus']"
                            [label]="'mapFilter.addNewAttribute' | transloco"
                            [type]="ButtonType.NEUTRAL"
                            (onClick)="addNewAttribute()" />
                    </div>
                    @if (layerAttributesFormArray.length > 1) {
                        <div class="flex flex-col h-full mt-6 ml-2">
                            <app-composition-attribute-filter-form
                                [filterAttributeCount]="layerAttributesFormArray.length"
                                [isEditDisabled]="isEditDisabled()"
                                [panelWidthTwoThird]="panelWidthTwoThird()" />
                        </div>
                    }
                </div>
            </app-expansion-panel>
        </div>

        <div class="bg-white rounded-xl p-6">
            <label class="flex items-center pb-2">
                <mat-checkbox formControlName="isShared" />
                <span
                    class="pl-2 overflow-hidden text-ellipsis whitespace-nowrap"
                    [class.text-secondary]="filterForm()!.controls.isShared.value">
                    {{ 'mapFilter.shareWithProjectUsers' | transloco }}
                </span>
            </label>
            <div class="flex flex-col w-full pr-2">
                <div class="flex items-center justify-between w-full">
                    <mat-form-field
                        appearance="outline"
                        class="w-2/3 text-body-1"
                        subscriptSizing="dynamic">
                        <input
                            class="placeholder:!text-gray-400 text-body-1"
                            matInput
                            type="text"
                            [formControlName]="'name'"
                            [placeholder]="'mapFilter.enterFilterName' | transloco" />
                    </mat-form-field>
                    <div class="flex gap-2">
                        @if (!mapFilterService.previewResultFilters()) {
                            <app-button
                                htmlType="button"
                                [disabled]="this.isLayerAttributesExpanded() && layerAttributesFormArray.invalid"
                                [icon]="['fas', 'eye']"
                                [label]="'preview' | transloco"
                                [type]="ButtonType.PRIMARY"
                                (click)="preview()" />
                        } @else {
                            <app-button
                                htmlType="button"
                                [icon]="['fas', 'times']"
                                [label]="'undo' | transloco"
                                [type]="ButtonType.SECONDARY"
                                (click)="mapFilterService.clearPreview()" />
                        }

                        <app-button
                            htmlType="submit"
                            [disabled]="
                                filterForm()!.invalid ||
                                filterForm()!.pristine ||
                                compositionControl.pending ||
                                compositionControl.invalid
                            "
                            [icon]="['fas', 'check']"
                            [label]="'save' | transloco"
                            [matTooltip]="buttonDisableReasons()"
                            [matTooltipDisabled]="!buttonDisableReasons().length"
                            [type]="ButtonType.PRIMARY"
                            (click)="mapFilterService.clearPreview()" />
                    </div>
                </div>
                @if (filterForm()!.controls.name.dirty) {
                    <!-- prevent to display both required and invalidField as the Angular validator always return onlyWhitespace when required -->
                    @if (filterForm()!.controls.name.errors?.['required']) {
                        <mat-error
                            >{{
                                formService.getErrorMessage({
                                    key: 'required',
                                    value: filterForm()!.controls.name.errors?.['required'],
                                })
                            }}
                        </mat-error>
                    } @else {
                        @for (error of filterForm()!.controls.name.errors | keyvalue; track error) {
                            <mat-error>{{ formService.getErrorMessage(error) }}</mat-error>
                        }
                    }
                }
            </div>
        </div>
    </form>
</div>
